import React, {useEffect, useState} from 'react';
import './page.scss'
import {AsideNavigation} from "../aside-navigation";
import {BodyCategories} from "../body-categories";
import Alert from "../alert";
import * as actions from '../../actions';
//import Home from "../home";
import {CATEGORIES} from "../../enums/categories";
import RegisterForm, {User} from "../register-form";
import AlertService from "../../services/alert";
import Sponsors from "../sponsors";

const Page: React.FC<any> = () => {
	
	const [show, setShow] = useState(false)
	const [votedSuccessfully, setVotedSuccessfully] = useState(false)
	const [submitDisabled, setSubmitDisabled] = useState(false)
	const [alertServiceValues, setAlertServiceValues] = useState({type: '', message: ''})
	const [category, setCategory] = useState(0)
	const [nominations, setNominations] = useState([])
	
	const getCategoryNominations = async () => {
		// Get all nominations in all categories
		const response = await actions.getNominations();
		setNominations(response.data.nominations);
	}

	const submitVote = async (user: User) => {
		setSubmitDisabled(true)
		const {status, error_code} = await actions.submitVote(user);
		if (status === 'success') {
			setVotedSuccessfully(true);
			setSubmitDisabled(false);
		} else if(status === 'error' && error_code === 'email_exists'){
			AlertService.createErrorMessage('Вече сте гласували с този Email!')
		} else {
			AlertService.createErrorMessage('Възникна проблем.\n Ще го отстраним в най-кратък период.')
		}
	}
	useEffect(() => {
	getCategoryNominations()
	}, [])

	const bodyContent = () => {
		if (category === CATEGORIES.BEGIN) {
			// Skipping intro screen for 2023
			setCategory(1);
			return <></>;
			//return <Home currentCategory={category} setCategory={setCategory}/>
		} else if (category > CATEGORIES.BEGIN && category < CATEGORIES.VOTE) {
			return <>
			<div className="container title"><img src='/images/title2025.png'/></div>
			<br />
			<br />
			<Sponsors imagePath={'sponsori2025_v10.png?v=3'} />
			<BodyCategories
				currentCategory={category}
				setCategory={setCategory}
				nominations={nominations[category]}
				setShow={setShow}
				setAlertServiceValues={setAlertServiceValues}/>
				{/* <Sponsors imagePath={'sponsors.png'} onBottom={true} /> */}
			</>
		} else if (votedSuccessfully) {
			return <div className='success-vote'>
					<h2>Вашият глас беше успешно запазен! <br /> Благодарим ви, че гласувахте за Годишни Музикални Награди на БГ Радио {new Date().getFullYear()}.</h2>
					<div><a target="_blank" style={{color:"#CDA755"}} href="https://www.kupibileti.bg/bg/about-event/818">Вземи твоя билет от kupibileti.bg</a></div>
				</div>;
		} else if (category === CATEGORIES.VOTE) {
			return <RegisterForm onSubmit={submitVote}
				currentCategory={category}
				setCategory={setCategory}
				setShow={setShow}
				submitDisabled={submitDisabled}
				setAlertServiceValues={setAlertServiceValues}/>
		} 
	}
	
	return (<div className="row">
		<aside className={"aside-nav col-sm-12 col-md-3"}>
			<AsideNavigation
				showCategory={(category: number) => setCategory(category)}
				currentCategory={category}/>
		</aside>
		<article className={"content col-sm-12 col-md-9"}>
			<Alert alerts={alertServiceValues} show={show}/>
			{bodyContent()}
		</article>
	</div>);
}

export default Page;
